<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="d-none" v-html="stringHtml"></div>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2">{{ Title }}</h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <b-button class="float-right grey-btn" @click="backGRNList">Back to GRNs</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="fadein">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-3 p-4">
            <b-row>
              <b-col md="3 pb-3">
                <label class="mb-0">GRN Number</label>
                <p>{{ detail.grn_no }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Date</label>
                <p>{{ detail.date }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Received Quantity</label>
                <p>{{ detail.received_qty }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Damaged Quantity</label>
                <p>{{ detail.damage_qty }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Lost Quantity</label>
                <p>{{ detail.lost_qty }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Supplier</label>
                <p>{{ detail.supplier }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">Place of Origin</label>
                <p>{{ detail.place_from }}</p>
              </b-col>
              <b-col md="3 pb-3">
                <label class="mb-0">GRN Remark</label>
                <p>{{ detail.remarks }}</p>
              </b-col>
              <b-col md="2" class="text-right print offset-md-10">
                <b-button
                  class="btn btn-theme w-100"
                  @click="printGrn()"
                  :disabled="printBtnEnable"
                >
                  <!-- <span>Print Receipt</span> -->
                  <font-awesome-icon icon="print" size="lg" />
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>
      <b-modal ref="print-grn" hide-header hide-footer centered @hidden="hidePrintModal">
        <div class="modal-head" style="border-bottom: 1px #c0c0c0 solid;">
          <b-row class="pb-3 print_box">
            <b-col>
              <h3 class="modal-title">Invoice</h3>
            </b-col>
            <b-col>
              <b-button class="float-right grey-outline-btn" @click="printInvoice">Print</b-button>
              <b-button
                style="margin-right:10px;"
                class="float-right grey-outline-btn"
                @click="hidePrintModal"
              >Close</b-button>
            </b-col>
          </b-row>
        </div>
        <div id="cool">
          <print-box :data="html"></print-box>
        </div>
        <!-- <template slot="modal-footer" center>
          <b-button variant="success" size="lg" @click="printInvoice">Print</b-button>
            <b-button variant="danger" @click="hidePrintModal">Cancel</b-button>
        </template>-->
      </b-modal>
      <section>
        <b-container fluid>
          <div class="table-dark-bg box-shadow cart-table-wrapper wow fadeIn grn">
            <table class="table cart-table mt-0 table-dark">
              <thead>
                <tr>
                  <th width="5" class="text-center">#</th>
                  <th width="20" class="text-left" style="padding-left: 0px !important;">Product</th>
                  <th width="10" class="text-center">Inventory Track</th>
                  <th width="10" class="text-center">Ordered Qty.</th>
                  <th width="10" class="text-center">Received Qty.</th>
                  <th width="10" class="text-center">Damaged Qty.</th>
                  <th width="10" class="text-center">Lost Qty.</th>
                  <th width="20" class="text-center">Remarks</th>
                  <th width="10" class="text-center">Status</th>
                  <th width="10"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detail.product_list" :key="index">
                  <td class="text-center" v-text="index + 1"></td>
                  <td style="padding-left: 0px !important;">
                    <p class="mb-0">
                      {{ item.name }}
                      <br />
                      {{ item.barcode }}
                    </p>
                  </td>
                  <td class="text-center">{{ item.status == "" ? "-" : item.status }}</td>
                  <td class="text-center" v-text="item.order_qty"></td>
                  <td class="text-center" v-text="item.received_qty"></td>
                  <td class="text-center" v-text="item.damage_qty"></td>
                  <td class="text-center" v-text="item.lost_qty"></td>
                  <td class="text-center">{{ item.remarks == "" ? "-" : item.remarks }}</td>
                  <td class="text-center">-</td>
                  <td class="float-right mr-2">
                    <b-button
                      @click="openQty(item)"
                      variant="secondary"
                      class="grey-btn"
                      :disabled="item.is_batch == 0 && item.is_serial == 0"
                    >Details</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-container>
      </section>
      <b-modal
        ref="grn-details-modal"
        title="Product Name & Description"
        no-close-on-backdrop
        hide-footer
        centered
        scrollable
      >
        <p class="batch-serial mb-2">Barcode {{ grnBatchSerial.barcode }}</p>
        <table class="table-grn table text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Batch/Serial</th>
              <th></th>
              <th>Received Qty.</th>
              <th>Damage Qty.</th>
              <!-- <th>Valid Till</th>
              <th>Amount</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="list in grnBatchSerial.batch" :key="list.id">
              <td></td>
              <!-- <td v-text="list.id"></td> -->
              <td>
                <p class="m-0">Batch</p>
              </td>
              <td>
                <p class="m-0">{{ list.batch_no }}</p>
              </td>
              <td>
                <p class="m-0">{{ grnBatchSerial.received_qty }}</p>
              </td>
              <td>
                <p class="m-0">{{ grnBatchSerial.damage_qty }}</p>
              </td>
            </tr>
            <tr v-for="(list, index) in grnBatchSerial.serial" :key="list.id">
              <td v-text="index + 1"></td>
              <!-- <td v-text="list.id"></td> -->
              <td>
                <p class="m-0">Serial</p>
              </td>
              <td>
                <p class="m-0">{{ list.serial_no }}</p>
              </td>
              <td>
                <p class="m-0">1</p>
              </td>
              <td style="opacity: 0.5">
                <p class="m-0">0</p>
              </td>
              <!-- <td v-text="list.expire_at"></td>
              <td v-text="list.amount"></td>-->
            </tr>
          </tbody>
        </table>
      </b-modal>
    </template>
  </dashboard>
</template>

<script>
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import PrintBox from "../components/PrintBox";
import qz from "../printer";
library.add(faPrint);

export default {
  name: "grn-details",
  components: {
    Dashboard,
    CatalogSearch,
    VSelect,
    Loading,
    PrintBox,
    FontAwesomeLayers
  },
  mounted() {
    // this.GRNDetails();
  },
  created() {
    this.GRNDetails();
    // console.log(this.grn_no);
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    printSize() {
      let size = 80;
      this.state.system.settings.print.map(item => {
        if (item.name == "bill_print") {
          size = item.width;
        }
      });
      return size;
    }
  },
  data() {
    return {
      Title: "GRN Details",
      loading: true,
      detail: [],
      html: "",
      printBtnEnable: false,
      changeData: customData,
      stringHtml: "",
      grnBatchSerial: []
    };
  },
  watch: {
    changeData: {
      handler(val) {
        let self = this;
        console.log("In Data");
        if (val.data.type == "print_grn") {
          if (val.data.status == "success") {
            self.printBtnEnable = true;
            console.log("Change Data");
          } else {
          }
        }
        if (val.data.type == "session_timeout") {
          console.log("Login Expire");
          let errorData = {
            msg: msg.LOGIN_REDIRECT,
            btntext: "Login",
            type: "logout"
          };
          this.$store.commit("showMessage", errorData);
        }
      },
      deep: true
    }
  },
  methods: {
    GRNDetails: function() {
      this.$loading = true;
      let data = {
        // id: this.$route.params.id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        grn_no: this.$route.params.grn_no,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/vendor/grn-details"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.detail = response.data.data;
          this.$loading = false;
        })
        .catch(err => {
          this.$loading = false;
        });
    },
    printGrn() {
      let self = this;
      let data = {
        url: "/vendor/grn-print"
      };
      if (typeof Android !== "undefined" && Android !== null) {
        axios
          .get(data.url, {
            params: {
              api_token: this.state.sessions.user.api_token,
              v_id: this.state.sessions.user.v_id,
              store_id: this.state.sessions.user.store_id,
              vu_id: this.state.sessions.user.vu_id,
              grn_no: this.$route.params.grn_no,
              terminal_id: this.state.system.settings.terminal_id,
              trans_from: this.state.system.trans_from
              // udidtoken: this.state.trans_from
            }
          })
          .then(res => {
            // console.log(res.data.print_data);
            let postData = { type: "print_grn", data: res.data.print_data };
            returnValue(postData);
            // self.printBtnEnable = true;
          });
        // console.log(data);
      } else {
        let manuName = "";
        if (this.state.system.printer != "") {
          manuName = this.state.system.printer;
        }
        this.$loading = true;
        let data = {
          url: "/vendor/grn-print"
        };
        axios
          .get(data.url, {
            params: {
              api_token: this.state.sessions.user.api_token,
              v_id: this.state.sessions.user.v_id,
              store_id: this.state.sessions.user.store_id,
              vu_id: this.state.sessions.user.vu_id,
              grn_no: this.$route.params.grn_no,
              trans_from: this.state.system.trans_from,
              terminal_id: this.state.system.settings.terminal_id,
              // udidtoken: this.state.trans_from,
              manufacturer_name: manuName
            }
          })
          .then(response => {
            // console.log(response.data.print_data);
            if (this.state.system.printer != "" && qz.websocket.isActive()) {
              this.stringHtml = response.data.print_data
                .replace(
                  /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                  ""
                )
                .replace(/<center>/gi, "<div class='cool-center'>")
                .replace(/<left>/gi, "<div class='cool-left'>")
                .replace(/<right>/gi, "<div class='cool-right'>")
                .replace(/<text>/gi, "<span>")
                .replace(/<\/text>/gi, "</span>")
                .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
              this.stringHtml =
                "<div class='webpos-print'>" + this.stringHtml + "</div>";
              // console.log(this.stringHtml);
              setTimeout(() => {
                this.printHtml();
              }, 1000);
              // this.printHtml(response.data.html_data);
            } else {
              this.$refs["print-grn"].show();
              this.html = response.data.html_data;
              self.printBtnEnable = true;
            }
            this.$loading = false;
          })
          .catch(err => {
            this.$loading = false;
          });
      }
    },
    hidePrintModal() {
      this.$loading = false;
      this.$refs["print-grn"].hide();
      this.$loading = false;
    },
    printInvoice() {
      let prtContent = document.getElementById("cool");
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write("<html><head><title>Print Bill</title>");
      WinPrint.document.write("<style>table{text-align:center}</style>");
      WinPrint.document.write("</head><body>");
      WinPrint.document.write("<div>");
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    backGRNList() {
      this.$router.push("/grn-list/");
    },
    printHtml() {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      // console.log(data);
      for (var i = 0; i < data.length; i++) {
        let tempData = data[i].childNodes;
        for (var j = 0; j < tempData.length; j++) {
          billData.push({
            content: tempData[j].textContent,
            size: tempData[j].textContent.length
          });
        }
      }
      let htmlData = "";
      htmlData = Object.keys(billData)
        .map(function(k) {
          let convert = "";
          if (billData[k].size == 1) {
            convert = billData[k].content;
            convert = convert.toString();
          } else {
            convert = billData[k].content.substr(
              0,
              billData[k].content.length - 1
            );
            convert = convert + "\x0A";
            convert = convert.toString();
          }
          return convert;
        })
        .join("");
      // console.log(htmlData.toString());

      let config = qz.configs.create(this.state.system.printer, {
        units: "mm"
      });
      let centerAlign = "\x1B" + "\x61" + "\x31";
      let paperCut = "\x1D" + "\x56" + "\x30";
      let lineBreak = "\x0A" + "\x0A" + "\x0A";
      let pdata = [centerAlign + htmlData + lineBreak + paperCut];
      qz.print(config, pdata);
      // console.log(pdata);
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-90px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },
    openQty(item) {
      console.log(item);
      this.grnBatchSerial = item;
      this.$refs["grn-details-modal"].show();
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.theme-dark .advice .customer-info-data {
  background: #202020;
  height: calc(100vh - 200px);
  @include custom-scrollbar();
  overflow-x: hidden;
  overflow-y: auto;
}
.text-muted {
  color: #c0c0c0 !important;
}
h5 {
  color: $grey-color;
}
.grn {
  height: calc(100vh - 290px);
}
.theme-dark .grn p {
  color: #fff;
}
.pill {
  background: $white-color;
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
h4 {
  color: $mid-grey;
}
.pending.pill {
  &:before {
    background: $success-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $danger-btn;
  }
}
.advice .vb-invisible .vb-content {
  padding-right: 0px !important;
  box-sizing: border-box !important;
}
.grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080 !important;
  width: 90px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff !important;
}
.batch-serial {
  font-weight: normal;
  font-size: 13px;
}
.table-grn tr th {
  background-color: #c0c0c0;
  font-weight: normal;
  padding: 4px 2px;
  font-size: 11.5px;
}
</style>
